const responseReducer = (state = "", action) => {
    switch (action.type) {
        case "setResponse":
            return action.payload;
        default:
            return state;
    }
};

export default responseReducer;
